<template>
  <div>
    <Loading v-if="showWait" />
    <div v-else>
      <PageTitle :main="`Projeção de Preço dos Insumos`" sub="" imagem="storagecost.png" />
      <PriceProjectionPlanGrid></PriceProjectionPlanGrid>
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import PriceProjectionPlanGrid from "./PriceProjectionPlanGrid.vue";
import Loading from "@/components/template/Loading.vue"
import { mapState } from "vuex";

export default {
  name: "PriceProjectionPlan",
  components: { PriceProjectionPlanGrid, PageTitle, Loading },
  computed: mapState(["showWait"]),
  data() {
    return {
      imagem: "",
    };
  },
  watch: {
  },
  beforeCreate() {
    this.$store.commit("setShowWait", true);
  },
  mounted() {
    this.$store.commit("setShowWait", false);
  }
};
</script>

<style scoped>
img {
  max-height: 45px;
}
</style>
